import { RaRecord, required } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { BooleanInput, GenerateNameInput, TextInput } from 'shared/react-admin/Inputs';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';

const transform = (data: RaRecord): RaRecord => {
  return {
    ...data,
    comment: data.comment || null,
  };
};

export const ProvidersCreate = () => (
  <CreateGuesserPage
    listName="Провайдеры"
    mutationOptions={{ onError: () => undefined }}
    rightActionsSlot={[
      <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
      <SaveButtonValidated key="save-button" label="Создать" />,
    ]}
    title="Cоздание провайдера"
    transform={transform}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        width: '100%',
        gap: '4px 24px',
        padding: '24px 0',
      }}
    >
      <BooleanInput
        defaultValue={true}
        label="Активен"
        size="small"
        source="active"
        sx={{
          marginBottom: '24px',
          gridColumn: ' 1 / span 2',
        }}
      />
      <GenerateNameInput
        fullWidth
        label="Название"
        size="small"
        source="name"
        validate={required()}
        variant="outlined"
      />
      <TextInput
        fullWidth
        label="Алиас"
        size="small"
        source="alias"
        validate={required()}
        variant="outlined"
      />
      <TextInput
        fullWidth
        helperText={false}
        label="Комментарий"
        multiline
        size="small"
        source="comment"
        sx={{
          gridColumn: ' 1 / span 2',
        }}
        variant="outlined"
      />
    </Box>
  </CreateGuesserPage>
);
